import { icon, Icon } from '../lib/fa-icons.js';
import Widget from './base.js'

export class PaywallSlides extends Widget {
  componentWillMount() {
    this.active = 0
    this.slide = this.slide.bind(this)
  }

  componentDidMount() {}

  slide() {
    this.active = this.active + 1
    if (this.active > this.testimonials.length - 1) this.active = 0
    const a = this.active
    document
      .querySelector('.js_slidetrack')
      .setAttribute('style', `transform:translateX(-${a}00%)`)

    document.querySelectorAll('.js_dot').forEach((dot) => {
      dot.classList.remove('--active')
    })

    document.querySelector(`.js_dot.index-${a}`).classList.add('--active')
  }

  get testimonials() {
    return [
      {
        text: 'TPM is way ahead of the curve in news reporting, often reporting on items that one may never have found out otherwise.',
        reader: 'KH',
      },
      {
        text: 'The best analysis, by a mile. When something is going to be important, I read about it on TPM long before the other news outlets have figured out that it is significant.',
        reader: 'MK',
      },
      {
        text: "TPM doesn't tiptoe around issues the way corporate-ad-dependent television and newspaper news programs do.",
        reader: 'EJM',
      },
      {
        text: 'What really sets TPM apart for me is that in addition to being whip-smart, it’s honest in a very particular way, a way in which even much of the best mainstream media (like the NYT and the WP) is not.',
        reader: 'JG',
      },
      {
        text: 'TPM is an incubator for investigative journalism. Membership supports that mission. No corporations, no billionaires, no foundations. Fully unionized',
        reader: 'NJ',
      },
      {
        text: 'I get insights with real historical perspective in real time, as events are unfolding.',
        reader: 'SH',
      },
      {
        text: 'One of the things I really appreciate about TPM is the refusal to play "both siderism" in the reporting or analysis.',
        reader: 'RM',
      },
      {
        text: 'It’s the analysis – even when I disagree. The merciless precision on the one hand, the kaleidoscopic range on the other.',
        reader: 'FC',
      },
      {
        text: "The analysis is original and thoughtful and evidence-based. [TPM] doesn't pretend to know what isn’t known.",
        reader: 'KM',
      },
      {
        text: 'I read normal media for detail, but TPM makes the news make sense.',
        reader: 'MS',
      },
      {
        text: 'The ad-free version is a tasty joy in the madness of the internet.',
        reader: 'KM',
      },
      {
        text: 'Reading TPM gives me the feeling that I can predict the weather and the future of the country at the same time.',
        reader: 'KS',
      },
      {
        text: 'I find that the synthesis of many sources and the non-hyperbolic, clear eyed analysis is not available anywhere else.',
        reader: 'GS',
      },
    ]
  }

  renderContent() {
    const makeSlides = () => {
      return this.testimonials.map((testimonial, i) => {
        return (
          <div class={`PaywallSlides__Slide index-${i}`}>
            <div class="PaywallSlides__SlideText">"{testimonial.text}"</div>
            <div class="PaywallSlides__SlideAttribution">
              -<span>Reader {testimonial.reader}</span>
            </div>
          </div>
        )
      })
    }

    const makeDots = () => {
      return this.testimonials.map((testimonial, i) => {
        return (
          <div
            class={`PaywallSlides__Dot index-${i} ${
              this.active === i ? '--active' : ''
            } js_dot`}
          >
            <Icon name="circle" style="solid" />
          </div>
        )
      })
    }

    return (
      <div>
        <div class="PaywallSlides__Slides">
          <div class="PaywallSlides__SlideTrack js_slidetrack">
            {makeSlides()}
          </div>
        </div>
        <div class="PaywallSlides__Controls">
          {makeDots()}{' '}
          <span class="PaywallSlides__Next" onClick={this.slide}>
            <span>NEXT</span>
            <Icon name="right-long" style="light" />
          </span>
        </div>
      </div>
    )
  }
}
